<script>
import formController from 'sky-engine/views/formController'
import { createViewVNode } from 'sky-engine/views/ViewManager'

export default {
  name: 'SkyDrawerRelationAdapter',
  components: {
    formController
  },
  props: {
    metaData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    dataProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    drawerProps: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  methods: {},
  created() {},
  data() {
    const metaView = this.metaData
    return {
      metaView: metaView
    }
  },
  render(h) {
    return createViewVNode(this.metaView, h)
  }
}
</script>
